import { useCallback } from 'react'
import { Button, PlusIcon, useSnackbar } from '@woorcs/design-system'
import { FormikHelpers } from 'formik'
import * as Optional from 'monocle-ts/Optional'
import * as Option from 'fp-ts/Option'
import { pipe, constant } from 'fp-ts/function'
import { useMutation, useQuery, UseQueryState } from 'urql'

import {
  ListPage,
  ListPageContent,
  ListPageHeader,
  PageTitle
} from '@app/components'

import {
  OrganizationList,
  AddOrganizationModal,
  OrganizationFormOrganization
} from '../../components'

import {
  OrganizationListQueryDocument,
  OrganizationListQuery,
  CreateOrganizationDocument
} from './__generated__/OrganizationsPage'

const organizationListQueryOptional = pipe(
  Optional.id<OrganizationListQuery>(),
  Optional.prop('organizations')
)

const organizationListQueryResultOptional = pipe(
  Optional.id<UseQueryState<OrganizationListQuery>>(),
  Optional.prop('data'),
  Optional.fromNullable,
  Optional.compose(organizationListQueryOptional)
)

export const OrganizationsPage = () => {
  const [query] = useQuery({
    query: OrganizationListQueryDocument
  })
  const { showSnackbar } = useSnackbar()

  const organizations = pipe(
    query,
    organizationListQueryResultOptional.getOption,
    Option.getOrElseW(constant([]))
  )

  const [, addOrganization] = useMutation(CreateOrganizationDocument)
  //   update(cache, { data }) {
  //     if (!data) {
  //       return
  //     }

  //     const addedOrganization = data.createOrganization

  //     if (!addedOrganization) {
  //       return
  //     }

  //     const organizations = pipe(
  //       cache.readQuery({
  //         query: OrganizationListQueryDocument
  //       }) as OrganizationListQuery,
  //       organizationListQueryOptional.getOption,
  //       Option.getOrElseW(constant([]))
  //     )

  //     cache.writeQuery({
  //       query: OrganizationListQueryDocument,
  //       data: {
  //         organizations: [addedOrganization, ...organizations]
  //       }
  //     })
  //   }
  // })

  const onManageOrganization = useCallback((id: string) => {
    window.location.replace(`/${id}`)
  }, [])

  const handleSubmit = useCallback(
    (
      organization: OrganizationFormOrganization,
      actions: FormikHelpers<OrganizationFormOrganization>
    ) => {
      addOrganization(organization)
        .then(() => {
          actions.resetForm({})
          showSnackbar({
            title: 'Organization added',
            variant: 'success'
          })
        })
        .catch((e: Error) => {
          showSnackbar({
            title: e.message,
            variant: 'danger'
          })
        })
        .finally(() => {
          actions.setSubmitting(false)
        })
    },
    [showSnackbar, addOrganization]
  )

  return (
    <ListPage>
      <ListPageHeader>
        <PageTitle>Organizations</PageTitle>
        <AddOrganizationModal
          title='Create organization'
          onSubmit={handleSubmit}
        >
          <Button leftIcon={<PlusIcon />}>Add organization</Button>
        </AddOrganizationModal>
      </ListPageHeader>
      <ListPageContent px={0} py={0}>
        <OrganizationList
          organizations={organizations}
          loading={query.fetching}
          onManageOrganization={onManageOrganization}
        />
      </ListPageContent>
    </ListPage>
  )
}
